import React from "react"
import AddIcon from "@mui/icons-material/Add"
import DeleteIcon from "@mui/icons-material/Delete"
import { IconButton, Tooltip } from "@mui/material"

import ContainerItemGenerico from "../../../../../components/Containers/ContainerItemGenerico"
import FormInputTexto from "../../../../../components/FormInputTexto"
import FormSelectInput from "../../../../../components/FormSelectInput"
import * as S from "./style"

export default function MultiMatchFilter({
    filtros,
    itensDoSelect,
    onAdicionarFiltro,
    onAlterarFiltro,
    onRemoverFiltro,
}) {
    const camposSelecionados = filtros
        .map(filtro => filtro.campo)
        .filter(Boolean)

    const quantidadeMaximaDeFiltros = filtros.length >= itensDoSelect.length

    const retornaOpcoesDisponiveis = (campoAtual) => {
        return itensDoSelect.filter(item => item === campoAtual || !camposSelecionados.includes(item))
    }

    return (
        <ContainerItemGenerico>
            <S.ContainerListaFiltros>
                {filtros.map((filtro, index) => (
                    <S.ContainerLinhaFiltro key={filtro.id}>
                        <S.ContainerCampo>
                            <h5>Campo</h5>
                            <FormSelectInput
                                value={filtro.campo}
                                onChange={(event) => onAlterarFiltro(filtro.id, { campo: event.target.value, valor: "" })}
                                itensDoSelect={retornaOpcoesDisponiveis(filtro.campo)}
                            />
                        </S.ContainerCampo>
                        <S.ContainerCampo>
                            <h5>Descrição</h5>
                            <FormInputTexto
                                value={filtro.valor}
                                onChange={(event) => onAlterarFiltro(filtro.id, { valor: event.target.value })}
                            />
                        </S.ContainerCampo>
                        <S.ContainerAcoesLinha>
                            {filtros.length > 1 && (
                                <Tooltip title="Remover filtro">
                                    <IconButton onClick={() => onRemoverFiltro(filtro.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {index === filtros.length - 1 && !quantidadeMaximaDeFiltros && (
                                <Tooltip title="Adicionar filtro">
                                    <IconButton onClick={onAdicionarFiltro}>
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </S.ContainerAcoesLinha>
                    </S.ContainerLinhaFiltro>
                ))}
            </S.ContainerListaFiltros>
        </ContainerItemGenerico>
    )
}
